import styled from 'styled-components';
import { getColor, maxContainer, StyleVars } from "core/utils";


export const Row = styled.div`
	${maxContainer(StyleVars.screenCjMinMaxContainer)}
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;

	> * {
		margin: 0px 16px;
		&:first-child {
			margin-left: 0px;
		}
	}
`;

export const LinksTitle = styled.div`
	font-weight: 600;
	font-size: 24px;
	color: ${getColor('gray')};

	line-height: 36px;

	@media only screen and (max-width: ${StyleVars.screenSm}) {
		width: 100%;
		margin-bottom: 20px;
		text-align: center;
	}
`;

export const ContactButtonContainer = styled.div`
	min-width: 200px;
	margin-top: 44px;
	margin-bottom: 44px;
	@media only screen and (max-width: ${StyleVars.screenSm}) {
		width: 100%;
	}
`;
